import React from 'react';
import { BiEdit, BiPlus, BiTrash } from 'react-icons/bi';

import Bouton from '../../UI/Bouton/Bouton';
import TaskBuilder from '../TaskBuilder/TaskBuilder';

import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import S from '../ProfilTasks/ProfilTasks.module.scss';

const TaskProfil = ({ task, onEdit, onDelete, onAddFunction }) => {
  if (!task || !task.id) {
    return (
      <div className={S.emptyState}>
        <h3>Aucune tâche sélectionnée</h3>
        <p>Sélectionnez une tâche dans le tableau pour voir les détails.</p>
      </div>
    );
  }

  const taskName = task.nom || task.name || 'Tâche sans nom';
  const taskId = task.id || task.task_id;
  const functionName = task.function_name || task?.function?.name;
  const functionId = task.function_id || task?.function?.id_function;

  return (
    <div className={S.profilContainer}>
      <div className={S.header}>
        <div className={S.headerInfo}>
          <div className={S.functionTitle}>
            <h2 className={S.functionName}>{taskName}</h2>
            <div className={S.functionMeta}>
              {taskId && (
                <span className={S.functionId}>ID tâche: {taskId}</span>
              )}
              {functionId && (
                <span className={S.functionId}>
                  Fonction: {functionName || 'N/A'} (ID: {functionId})
                </span>
              )}
            </div>
          </div>
        </div>
        <div className={S.headerActions}>
          <Bouton
            type={type_btn.secondary}
            rond={true}
            taille="small"
            cliquer={() => onEdit && onEdit(task)}
            className={S.actionBtn}
          >
            <BiEdit size={16} />
          </Bouton>
          {onAddFunction && (
            <Bouton
              type={type_btn.primary}
              rond={true}
              taille="small"
              cliquer={() => onAddFunction(task)}
              className={S.actionBtn}
            >
              <BiPlus size={16} />
            </Bouton>
          )}
          <Bouton
            type={type_btn.danger}
            rond={true}
            taille="small"
            cliquer={() => onDelete && onDelete(task)}
            className={S.actionBtn}
          >
            <BiTrash size={16} />
          </Bouton>
        </div>
      </div>
      <div className={S.tabContent}>
        <TaskBuilder
          initialTask={task}
          isEditMode={true}
          readOnly={true}
          annuler={() => {}}
          sauvegarderTache={() => {}}
        />
      </div>
    </div>
  );
};

export default TaskProfil;
